module.exports = __webpack_public_path__ + "img/parsehub.f99d4c5f.png";